export * from './select-fan-table.component';
